/**
=========================================================
* Arakan - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";

// Settings page components
import FormField from "components/FormField";

import { IconButton, InputLabel } from "@mui/material";

// Import from Material-UI icons
import AttachFileIcon from "@mui/icons-material/AttachFile";
// or
import MDInput from "components/MDInput";
import LangSwitcher from "components/LangSwitcher";
import MDEditor from "components/MDEditor";

function LangForm({
  project,
  id,
  info,
  setInfo,
  changeHandler,
  notification,
  setNotification,
  errors,
  setErrors,
}) {
  const baseUrl = process.env.REACT_APP_API_URL;

  const [selectedLang, setSelectedLang] = useState();
  const [oldSelectedLang, setOldSelectedLang] = useState();

  // get data from infoHis when change language selection from lang switcher
  useEffect(() => {
    if (!project.id || !selectedLang) return;

    let newData = {};
    if (oldSelectedLang.code !== selectedLang.code) {
      newData = info.translations;
      newData[oldSelectedLang.code] = {
        ...info.translations[oldSelectedLang.code],
        languages_code: oldSelectedLang.code,
      };
    }
    if (oldSelectedLang.code === selectedLang.code)
      setInfo({
        translations: project.translations,
      });
    else
      setInfo({
        translations: newData,
      });
  }, [project, selectedLang]);

  useEffect(() => {
    if (!selectedLang?.code) return;

    setInfo((prev) => {
      // Clone translations
      const translations = { ...(prev.translations || {}) };

      // If this language doesn’t exist, initialize it
      if (!translations[selectedLang.code]) {
        translations[selectedLang.code] = {
          name: "",
          summary: "",
          desc: "",
          languages_code: selectedLang.code,
        };
      }

      return { ...prev, translations };
    });
  }, [selectedLang]);

  const changeReportFileHandler = (e) => {
    changeHandler(
      { target: { name: "report_file", value: e.target.files[0] } },
      selectedLang.code,
    );
  };

  const safeHistory = info?.translations?.[selectedLang?.code] || {};

  return (
    <>
      <Card sx={{ overflow: "visible", p: 5 }}>
        <MDBox p={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <LangSwitcher
                setSelectedLang={setSelectedLang}
                setOldSelectedLang={setOldSelectedLang}
                stickyNavbar={false}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <FormField
                onChange={(e) => changeHandler(e, selectedLang.code)}
                label="الاسم"
                name="name"
                value={safeHistory?.name ?? ""}
                error={errors[`name-${selectedLang?.code}`]}
              />
            </Grid>
            <Grid item xs={12} lg={8}>
              <FormField
                onChange={(e) => changeHandler(e, selectedLang.code)}
                label="الملخص"
                name="summary"
                value={safeHistory?.summary ?? ""}
                error={errors[`summary-${selectedLang?.code}`]}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <MDTypography variant="h6" gutterBottom>
                التفاصيل
              </MDTypography>
              <MDEditor
                onChange={(e) => changeHandler(e, selectedLang.code)}
                label="التفاصيل"
                name="desc"
                value={safeHistory?.desc ?? ""}
                error={errors[`desc-${selectedLang?.code}`]}
                placeholder="اكتب التفاصيل هنا..."
                success={!errors[`desc-${selectedLang?.code}`]}
              />
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </>
  );
}

export default LangForm;
